import {http} from '@/helpers/http-helper';

class QueryRating {
    constructor(uuid, adviser, query, avgRating, createdAt, comments, contact) {
        this.uuid = uuid;
        this.adviser = adviser;
        this.query = query;
        this.avgRating = avgRating;
        this.createdAt = createdAt;
        this.comments = comments;
        this.contact = contact;
    }
}

export const createQueryRating = (
    token,
    attention,
    knowledge,
    resolution,
    satisfaction,
    comments,
    contact
) => {
    return new Promise((resolve, reject) => {
        const url = 'public/queries/rating/' + token;
        http.post(url, {
            attention,
            knowledge,
            resolution,
            satisfaction,
            comments,
            contact
        })
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryRatings = () => {
    return new Promise((resolve, reject) => {
        const url = 'queries/ratings';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let queryRatings = [];

                    response.data.forEach((queryRating) => {
                        queryRatings.push(new QueryRating(
                            queryRating.uuid,
                            queryRating.adviser,
                            queryRating.query,
                            queryRating.avgRating,
                            new Date(queryRating.createdAt),
                            queryRating.comments,
                            queryRating.contact
                        ));
                    });

                    resolve(queryRatings);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryRatingStatistics = () => {
    return new Promise((resolve, reject) => {
        const url = 'queries/ratings/statistics';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};